import React from "react";
import cx from "classnames";
import { Image } from "src/components/image";
import { CTA } from "src/components/cta";

import styles from "./product-offering.module.css";

interface ProductOfferingProps {
  module: {
    headline?: string;
    subheadline?: string;
    cards: [
      {
        flag?: string;
        title: string;
        subtitle?: string;
        image: {
          asset: {
            _id: string;
          };
          hotspot: {
            x: number;
            y: number;
          };
        };
        primaryPrice: string;
        secondaryPrice: string;
        cta?: any;
      }
    ];
  };
}
export const ProductOffering = ({ module }: ProductOfferingProps) => {
  const { headline, subheadline, cards } = module;
  return (
    <div className={cx(styles.productOffering)}>
      <div className={styles.introCopy}>
        <h2 className={cx("subhead ac", styles.headline)}>{headline}</h2>
        <p className={cx("body ac", styles.subheadline)}>{subheadline}</p>
      </div>
      <div className={styles.cards}>
        {cards &&
          cards.map((card, index) => (
            <div className={styles.card} key={index}>
              {card.flag && (
                <span className={cx("small-caps-12", styles.flag)}>
                  {card.flag}
                </span>
              )}
              <div className={styles.cardDetails}>
                <p className={cx("body", styles.cardCopy)}>
                  <strong>{card.title}</strong>
                  {card.subtitle}
                </p>
                {card.image && (
                  <Image
                    className={styles.cardImage}
                    imageId={card.image.asset._id}
                    width={345}
                    style={{
                      height: "100%",
                      width: "100%",
                      position: "absolute"
                    }}
                    objectPosition={
                      card.image.hotspot &&
                      `${card.image.hotspot.x * 100}% ${card.image.hotspot.y *
                        100}%`
                    }
                  />
                )}
              </div>
              <div className={cx(styles.cardPricing)}>
                <h4 className={cx("subhead ac")}>{card.primaryPrice}</h4>
                <h5 className={cx("body body--small")}>
                  {card.secondaryPrice}
                </h5>
              </div>
              {card.cta && (
                <CTA className={styles.cardCta} cta={card.cta} style="solid" />
              )}
            </div>
          ))}
      </div>
    </div>
  );
};
